var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"khButton",staticClass:"khButton"},[_c('van-button',{attrs:{"disabled":_vm.diabled},on:{"click":_vm.clickButton}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }